import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=02fbd2f1&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=ts&"
export * from "./MenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=02fbd2f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbd2f1",
  null
  
)

export default component.exports